import FormTextInput from '../Form/FormTextInput';
import {px, percent} from '@packages/systems/core/utils/WebflowCssSubset';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import withAttribute from './withAttribute';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT,
} from '@packages/systems/commerce/constants';
import {Atom} from '@packages/systems/wfdl';

const formTextInputConfig = Atom.getConfigShape(FormTextInput);

const config = Atom.create({
  ...formTextInputConfig,
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT
  )(formTextInputConfig.render),
  displayName: 'Discount Code',
  constraints: {
    ancestors: [{is: 'CommerceCheckoutDiscounts', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        ...checkoutInputStyle,
        noPseudo: {
          ...checkoutInputStyle.noPseudo,
          width: 'auto',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
          marginBottom: px(0),
          minWidth: px(0),
        },
      },
      tiny: {
        ...mobileCheckoutInputStyle,
      },
    },
  },
});

export default config;
